// components/CustomDivider.jsx
import { Typography } from "@mui/material";
import React from "react";

const CustomDivider = ({
  children,
  color = "#ccc",
  thickness = "1px",
  margin = "16px 0",
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        margin: margin,
        width: "100%",
      }}
    >
      {children}
      <div
        style={{
          flexGrow: 1,
          height: thickness,
          backgroundColor: color,
        }}
      />
    </div>
  );
};

export default CustomDivider;
